import Vue from 'vue'
import VueMeta from 'vue-meta'
import BootstrapVue from 'bootstrap-vue'
import VueAnalytics from 'vue-analytics'
import App from './App.vue'
import router from './router'
import store from './store'

// SEO Metas
Vue.use(VueMeta)

// CSS Framework
Vue.use(BootstrapVue)

// Vuesax Framework
import { vsPopup, vsInput, vsIcon } from 'vuesax'
import 'vuesax/dist/vuesax.css'
import 'material-icons/iconfont/material-icons.css';
Vue.use(vsPopup)
Vue.use(vsInput)
Vue.use(vsIcon)

// Google Analytics
Vue.use(VueAnalytics, {
  id: 'G-S7LVSGJ0TV',
  router
});

// Icons
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(fas)
library.add(fab)
Vue.component('fa-icon', FontAwesomeIcon)

// Layouts
import Default from '@/layouts/Default'
import Auth from '@/layouts/Auth'
import Profile from '@/layouts/Profile'
import Deposit from '@/layouts/Deposit'
import Exam from '@/layouts/Exam'
import ExamPurchase from '@/layouts/ExamPurchase'
import Testing from '@/layouts/Testing'
import Popup from '@/layouts/Popup'

Vue.component('default-layout', Default)
Vue.component('auth-layout', Auth)
Vue.component('profile-layout', Profile)
Vue.component('deposit-layout', Deposit)
Vue.component('exam-layout', Exam)
Vue.component('exam-purchase-layout', ExamPurchase)
Vue.component('testing-layout', Testing)
Vue.component('exam-purchase-confirm-layout', ExamPurchase)
Vue.component('popup-layout', Popup)

import moment from 'moment'

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('YYYY-MM-DD hh:mm')
  }
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
